import { GET_XL } from "../actions/constants";

const xl = (state = { xlData: [] }, action) => {
  switch (action.type) {
    case GET_XL:
      return { ...state, xlData: action.payload };

    default:
      return state;
  }
};

export default xl;
